import { useEffect, useState } from 'react';
import Select from 'react-select';
import { GetEntryData} from "../../store/purchaseOrderAtom";




function PurchaseSearchItem(props) {
    const masterData = GetEntryData();
    const [customOption, setCustomOption] = useState([]);
  

    useEffect(()=> {
     const tempData =  masterData['Items']?.map((element)=> {
        return ({...element, label:`${element?.Item_Name}`})
      }
      );
      setCustomOption(tempData)
    },[masterData])


    const handleChange = (item)=> {
        props.currentSelectedItem(item)
    }
  

    return ( 
        <>
        <div className="">
        <small>Select item</small>
        <div >
        <Select  className="lg:w-[38.5vw] "  options={customOption} onChange={handleChange}  />

        </div>
        </div>

        
        </>
     );
}

export default PurchaseSearchItem;
